<template>
  <div v-if="arquivosARR.length != 0">
    <div class="text-center">
      <h4><b> Arquivos Liberados</b></h4>
    </div>
    <table>
      <tr>
        <th>Nome</th>
        <th>Versão</th>
        <th>Situação</th>
        <th>Download</th>
        <th>Data/Hora de Confirmação</th>
      </tr>
      <tr v-for="(a, i) in arquivosARR" :key="i">
        <td>{{a.ARQNOME}}</td>
        <td>{{a.ARQVERSAO}}</td>
       <td>{{a.ARQCLISITUACAO == 0 ? "Pendente" : a.ARQCLISITUACAO == 1 ? "Baixando" : "Recebido"}}</td>
       <td>{{a.ARQCLITIPODOWNLOAD == 1 ? "Instalação Forçada" : a.ARQCLITIPODOWNLOAD == 0 ? "Critério do Cliente" : "Download Silencioso"}}</td>
       <td>{{a.ARQDATAHORACONF | formatDateNormal}}</td>
      </tr>
    </table>
  </div>
</template>
<script>
import * as Arquivos from "../../providers/arquivos.service";
export default {
  props: ["cliente"],
  data() {
    return {
      arquivosARR: []
    };
  },
  created() {
    this.getLiberados(this.cliente);
  },
  methods: {
    getLiberados(cliente) {
      var self = this;
      Arquivos.listaArquivosLiberados({ CLICODIGO: cliente.CLICODIGO }).then(
        r => {
          self.arquivosARR = r.Rows;
        }
      );
    }
  }
};
</script>
<style>
table {
  width: 100%;
}

td,
th {
  border: 1px solid rgb(233, 233, 233);
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #CFDFE5;
}
</style>